import { Card, Select, notification } from "antd";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import cuid from "cuid";

const AVAILABLE_REGIMES = [
  { code: "SECURITE_SOCIALE", name: "Sécurité Sociale" },
  { code: "ALSACE_MOSELLE", name: "Alsace-Moselle" },
  { code: "REGIME_SPECIAL", name: "Régime Spécial" },
  { code: "REGIME_SALARIES_AGRICOLES", name: "Salariés Agricoles" },
  { code: "MSA_RL", name: "MSA Alsace-Moselle" },
  { code: "SECURITE_SOCIALE_INDEPENDANTS", name: "Indépendants" },
];

const RegimeManager = ({ regimes, planId, setFieldValue }) => {
  const [createRegime] = useMutation(graphql.mutations.CREATE_REGIME);
  const [deleteRegime] = useMutation(graphql.mutations.DELETE_REGIME);

  const selectedCodes = (regimes || []).map((r) => r.code);

  const handleChange = async (newCodes) => {
    const added = newCodes.filter((code) => !selectedCodes.includes(code));
    const removed = selectedCodes.filter((code) => !newCodes.includes(code));

    let updatedRegimes = [...(regimes || [])];

    for (const code of added) {
      const def = AVAILABLE_REGIMES.find((r) => r.code === code);
      if (!def) continue;
      const id = cuid();
      const regime = {
        id,
        name: def.name,
        code: def.code,
        order: updatedRegimes.length + 1,
      };
      try {
        await createRegime({
          variables: {
            data: { ...regime, insurancePlan: { id: planId } },
          },
        });
        updatedRegimes.push(regime);
      } catch (err) {
        notification.error({ message: `Échec de l'ajout de ${def.name}` });
      }
    }

    for (const code of removed) {
      const regime = updatedRegimes.find((r) => r.code === code);
      if (!regime) continue;
      try {
        await deleteRegime({ variables: { where: { id: regime.id } } });
        updatedRegimes = updatedRegimes.filter((r) => r.code !== code);
      } catch (err) {
        notification.error({
          message: `Échec de la suppression de ${regime.name}`,
        });
      }
    }

    setFieldValue("regimes", updatedRegimes);
  };

  return (
    <Card title="Régimes" className="m-bottom-16">
      <p style={{ color: "#64748B", fontSize: 13, marginBottom: 12 }}>
        Sélectionnez les régimes sociaux pris en charge pour la tarification
      </p>
      <Select
        mode="multiple"
        style={{ width: "100%" }}
        placeholder="Sélectionner les régimes..."
        value={selectedCodes}
        onChange={handleChange}
        options={AVAILABLE_REGIMES.map((r) => ({
          value: r.code,
          label: r.name,
        }))}
      />
    </Card>
  );
};

export default RegimeManager;
